import { render, staticRenderFns } from "./opsgenie.vue?vue&type=template&id=11c34274&scoped=true&"
import script from "./opsgenie.vue?vue&type=script&lang=js&"
export * from "./opsgenie.vue?vue&type=script&lang=js&"
import style0 from "./opsgenie.vue?vue&type=style&index=0&id=11c34274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c34274",
  null
  
)

export default component.exports